// extracted by mini-css-extract-plugin
export var formContainer = "FormSection-module--formContainer--ivtPq";
export var formContent = "FormSection-module--formContent--WRiUO";
export var formDescription = "FormSection-module--formDescription--LT8C-";
export var formHeader = "FormSection-module--formHeader--2TxQk";
export var formImage = "FormSection-module--formImage--prxu4";
export var formSectionWrapper = "FormSection-module--formSectionWrapper--xMhLN";
export var formSubtitle = "FormSection-module--formSubtitle--JKNKB";
export var formTitle = "FormSection-module--formTitle--FsEDU";
export var headerSection = "FormSection-module--headerSection--TELYi";
export var imageContainer = "FormSection-module--imageContainer--eT7Bc";
export var mainDescription = "FormSection-module--mainDescription--4sko3";
export var mainTitle = "FormSection-module--mainTitle--QbYhj";